import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = getLatestArticles(6);

  const imageUrls: Record<string, string> = {
    'article-cover-01': 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20posters%20collage%20on%20a%20dark%20wall%2C%20warm%20spotlight%20illumination%2C%20film%20reel%20decorations%2C%20cozy%20cinema%20review%20blog%20atmosphere%2C%20rich%20dark%20red%20and%20golden%20accents%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=article-img-01&orientation=landscape',
    'article-cover-02': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20court%20scene%20with%20ornate%20robes%20and%20golden%20decor%2C%20dramatic%20lighting%20through%20paper%20windows%2C%20historical%20drama%20aesthetic%2C%20rich%20red%20and%20gold%20tones%2C%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=article-img-02&orientation=landscape',
    'article-cover-03': 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20studio%20with%20character%20designs%20and%20storyboards%20on%20walls%2C%20warm%20creative%20workspace%2C%20ink%20paintings%20and%20digital%20screens%2C%20artistic%20atmosphere%2C%20soft%20natural%20light%2C%20no%20text&width=800&height=500&seq=article-img-03&orientation=landscape',
    'article-cover-04': 'https://readdy.ai/api/search-image?query=Colorful%20TV%20variety%20show%20studio%20set%20with%20bright%20lights%20and%20game%20props%2C%20energetic%20atmosphere%2C%20vibrant%20coral%20and%20yellow%20lighting%2C%20professional%20studio%20photography%2C%20dynamic%20composition%2C%20no%20text&width=800&height=500&seq=article-img-04&orientation=landscape',
    'article-cover-05': 'https://readdy.ai/api/search-image?query=Deep%20space%20cosmic%20scene%20with%20distant%20galaxies%20and%20nebula%2C%20sci-fi%20mysterious%20atmosphere%2C%20dark%20blue%20and%20purple%20cosmic%20lighting%2C%20vast%20universe%20scale%2C%20minimalist%20space%20composition%2C%20no%20text%2C%20no%20planets&width=800&height=500&seq=article-img-05&orientation=landscape',
    'article-cover-06': 'https://readdy.ai/api/search-image?query=Warm%20family%20movie%20night%20scene%20with%20popcorn%20and%20cozy%20living%20room%20atmosphere%2C%20soft%20warm%20golden%20lighting%2C%20comfortable%20sofa%20with%20blankets%2C%20home%20cinema%20vibe%2C%20editorial%20lifestyle%20photography%2C%20no%20text&width=800&height=500&seq=article-img-06&orientation=landscape',
  };

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新资讯
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            影视行业动态、深度剧评、观影指南，掌握最新影视资讯
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={imageUrls[article.imageSeq] || imageUrls['article-cover-01']}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views.toLocaleString()} 阅读
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/article/article-1"
            className="inline-flex items-center gap-2 px-6 py-2.5 border border-background-300 rounded-full text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-500 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多资讯
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}